import { ColumnDef } from "@tanstack/react-table";
import { DetailedUserWithStats } from "@/user/user.d";

export const SignupsCol = (): ColumnDef<DetailedUserWithStats> => ({
  header: "Signups",
  accessorFn: (row) => row.stats?.signup_count ?? 0,
  size: 100,
});
